import angular from 'angular';

import SubscriptionSettingsComponent from './subscription.cmpt';

export default angular
    .module('application.scene.authorized.scene.settings.scene.subscription', [])
    .component(SubscriptionSettingsComponent.selector, SubscriptionSettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.subscription', {
        url: '/subscription',
        component: SubscriptionSettingsComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/subscription/index.js